import * as React from "react";
import { Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Facebook from "./img/Facebook.svg";
import Linkedin from "./img/Linkedin.svg";
import Mail from "./img/Mail.svg";
import Twitter from "./img/Twitter.svg";
import X from "./img/X-Articles.svg";
import WhatsApp from "./img/WhatsApp.svg";

function SocialIconsWidget(props) {
  const { isSidebar, offsetTop, template } = props;

  const useStyles = makeStyles(() => ({
    socialIconFirst: {
      paddingRight: "6px",
    },
    socialIcon: {
      paddingLeft: "6px",
      paddingRight: "6px",
    },
    socialIconLast: {
      paddingLeft: "6px",
    },
    anchor: {
      display: "flex",
      height: "100%",
    },
    sidebarPositioningLeft: {
      display: "flex",
      flexDirection: "column",
      // marginTop: `${offsetTop}px`,
      alignContent: "flex-end",
      position: "sticky",
    },
    sidebarPositioningRight: {
      display: "flex",
      flexDirection: "column",
      // marginTop: `${offsetTop}px`,
      alignContent: "flex-start",
      position: "sticky",
    },
    socialIconFirstSidebar: {
      paddingBottom: "4px",
    },
    socialIconSidebar: {
      paddingTop: "4px",
      paddingBottom: "4px",
    },
    socialIconLastSidebar: {
      paddingTop: "4px",
    },
    container:{
      paddingTop: "24px",
      paddingBottom: "24px",
    }
  }));

  const classes = useStyles();

  const pageUrl = typeof window !== "undefined" ? window.location.href : "";

  const iconClicked = (pageUrl, socialChannel) => {

    window.brazeSocialIcon(pageUrl, socialChannel)
  }
  return (
    <Grid
      xs={12}
      style={{ marginTop: `${offsetTop}px` }}
      container
      alignItems={"center"}
      className={
        isSidebar
          ? template === "C-SB" || !template
            ? classes.sidebarPositioningLeft
            : classes.sidebarPositioningRight
          : classes.container
      }
    >
      <Grid item>
        <a
          target="_blank"
          rel="noopener noreferrer"
          className={classes.anchor}
          onClick={() => iconClicked(pageUrl, "Facebook")}
          href={`https://www.facebook.com/sharer.php?u=${pageUrl}`}
        >
          <img
            className={
              isSidebar
                ? classes.socialIconFirstSidebar
                : classes.socialIconFirst
            }
            src={Facebook}
          />
        </a>
      </Grid>
      <Grid item>
        <a
          target="_blank"
          rel="noopener noreferrer"
          className={classes.anchor}
          onClick={() => iconClicked(pageUrl, "X/Twitter")}
          href={`https://twitter.com/intent/tweet?url=${pageUrl}`}
        >
          <img
            className={
              isSidebar ? classes.socialIconSidebar : classes.socialIcon
            }
            src={X}
          />
        </a>
      </Grid>
      <Grid item>
        <a
          target="_blank"
          rel="noopener noreferrer"
          className={classes.anchor}
          onClick={() => iconClicked(pageUrl, "Linkedin")}
          href={`https://www.linkedin.com/shareArticle?mini=true&url=${pageUrl}`}
        >
          <img
            className={
              isSidebar ? classes.socialIconSidebar : classes.socialIcon
            }
            src={Linkedin}
          />
        </a>
      </Grid>
      <Grid item>
        <a
          target="_blank"
          rel="noopener noreferrer"
          className={classes.anchor}
          onClick={() => iconClicked(pageUrl, "WhatsApp")}
          href={`https://api.whatsapp.com/send?text=${pageUrl}`}
        >
          <img
            className={
              isSidebar ? classes.socialIconSidebar : classes.socialIcon
            }
            src={WhatsApp}
          />
        </a>
      </Grid>
      <Grid item>
        <a
          target="_blank"
          rel="noopener noreferrer"
          className={classes.anchor}
          onClick={() => iconClicked(pageUrl, "Email")}
          href={`mailto:?body=${pageUrl}`}
        >
          <img
            className={
              isSidebar ? classes.socialIconLastSidebar : classes.socialIconLast
            }
            src={Mail}
          />
        </a>
      </Grid>
    </Grid>
  );
}

export default SocialIconsWidget;
